import React, { useContext, useEffect, useState } from "react";
import SupplierContext from "../../../../contexts/SupplierContext";
import OrderWorkflowConfigurator from "../OrderWorkflowConfigurator/OrderWorkflowConfigurator";
import UserContext from "../../../../contexts/UserContext";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IWorkflow from "../../../../models/IWorkflow";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OwButton from "../../../shared/OwButton/OwButton";
import IOrder_Progress_State from "../../../../models/IOrder_Progress_State";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IProcessWorkflowDTO from "../../../../models/DTO/IProcessWorkflowDTO";
import INotification from "../../../../models/INotification";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import { Socket } from "socket.io-client";

type Props = {
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    workflow: IWorkflow;
    closeDock: () => void;
};

export const MultiWorkflowEditor: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);

    const [hasUpdate, setHasUpdate] = useState(false);
    const [updatedWorkflow, setUpdatedWorkflow] = useState<IOrder_Progress_State[]>(props.workflow.detail);

    useEffect(() => {
        props.socket.on(EndpointsEnum.WorkflowsOnProcessWorkflow, onProcessWorkflow);

        return () => {
            props.socket.removeListener(EndpointsEnum.WorkflowsOnProcessWorkflow, onProcessWorkflow);
        };
    }, []);

    const updateWorkflowFn = (e: any, subProp?: string | undefined) => {
        const value = e.target.value;

        setHasUpdate(true);
        setUpdatedWorkflow(value);
    };

    const saveChanges = () => {
        const payload: IProcessWorkflowDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            workflow: {
                ...props.workflow,
                detail: updatedWorkflow,
            },
        };

        props.socket.emit(EndpointsEnum.WorkflowsProcessWorkflow, payload);
    };

    const onProcessWorkflow = () => {
        const notification: INotification = {
            message: "successfully_saved_workflow",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        props.notifyFn(null, notification);

        props.closeDock();
    };

    return (
        <div className={"MultiWorkflowEditor"}>
            <div>
                <OwTitle title={props.workflow.name} disableTranslation={true} />
                {hasUpdate ? <OwButton title={"save_changes"} fn={saveChanges} /> : null}
            </div>
            <OrderWorkflowConfigurator
                userModel={userModel}
                supplierModel={supplierModel}
                updateFn={updateWorkflowFn}
                workflow={props.workflow}
            />
        </div>
    );
};
